export default {
  brand: 'CSSBuy Spreadsheet',
  home: 'Home',
  article: 'Guide',
  language: 'Language',
  exploreSpreadsheet: 'Explore CSSBuy Spreadsheet',
  buyItNow: 'Buy It Now',
  categories: 'Categories',
  selectCategory: 'Select a category',
  allCategories: 'All Categories',
  popularCategories: 'Popular Categories',
  latestGuide: 'Latest Guide',
  readGuide: 'Read Full Guide',
  backToHome: 'Back to Home',
  shoppingGuide: 'Shopping Guide',
  products: 'Products',
  productsTitle: 'Product Catalog',
  productsSubtitle: 'Browse our curated collection of 100+ products from top brands. Click to buy on our main store.',
  allProducts: 'All Products',
  featuredProducts: 'Featured Products',
  viewAllProducts: 'View All Products',
  ctaReady: 'Ready to shop?',
  ctaText: 'Visit our main store for the full catalog and latest arrivals.',
  visitStore: 'Visit Main Store',
  pillarTitle: 'Pillar Articles',
  pillarSubtitle: 'In-depth guides to expand your knowledge',
  articleLinkHomePrompt: 'Explore more guides and resources on our homepage.',
  'footer.description': 'CSSBuy Spreadsheet is an independent resource to help shoppers research products, compare options, and find helpful information before placing an order.',
  'footer.links': 'Quick Links',
  'footer.resources': 'Resources',
  'footer.contact': 'Contact',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.disclaimer': 'Disclaimer',
  'footer.copyright': '© 2026 cssbuybr.work. All rights reserved.',
  safetyDisclaimer: 'This website is an independent informational resource. Always verify current information before making a purchase.',
  heroEyebrow: 'CSSBuy Spreadsheet Resource',
  heroTitle: 'CSSBuy Spreadsheet — Guides, Lists & Resources',
  heroDescription: 'Find and explore CSSBuy Spreadsheet, product lists, research guides, QC information, warehouse, shipping, coupons and safety tips before placing your order.',
  ctaExplore: 'Explore CSSBuy Spreadsheet',
  ctaGuide: 'View CSSBuy Guide',
  trustLine: 'Practical guides • Updated content • Portuguese, English & Deutsch',
  spreadsheetTitle: 'CSSBuy Spreadsheet: find products more easily',
  spreadsheetDesc: 'CSSBuy Spreadsheet helps organize product research, compare options and find important information before buying. Here you will find guides, lists, tips and resources to research more efficiently. Always check current information before placing an order.',
  spreadsheetCta: 'Explore the Spreadsheet',
  whatIsTitle: 'What is a CSSBuy Spreadsheet?',
  whatIsDesc: 'A CSSBuy Spreadsheet is an organized tool that lists products, links, categories, sellers and research information. It allows you to check details, compare options and make more informed decisions before buying. The tool is useful for anyone who wants to research products in a structured way and find the best available options.',
  guidesTitle: 'CSSBuy Guides for Beginners',
  guideCard1: 'How to Use CSSBuy Spreadsheet',
  guideCard2: 'CSSBuy Review',
  guideCard3: 'CSSBuy Shipping Cost',
  guideCard4: 'CSSBuy Warehouse',
  guideCard5: 'CSSBuy QC',
  guideCard6: 'CSSBuy Safety',
  reviewTitle: 'CSSBuy Review: what to check before using',
  reviewAspect1: 'Platform',
  reviewAspect1Desc: 'Features and functionality',
  reviewAspect2: 'Products',
  reviewAspect2Desc: 'Information and links',
  reviewAspect3: 'Sellers',
  reviewAspect3Desc: 'History and trust signals',
  reviewAspect4: 'QC',
  reviewAspect4Desc: 'Photos and potential issues',
  reviewAspect5: 'Shipping',
  reviewAspect5Desc: 'Method, weight and destination',
  reviewAspect6: 'Costs',
  reviewAspect6Desc: 'Fees and services',
  reviewAspect7: 'Safety',
  reviewAspect7Desc: 'Account and payment',
  reviewCta: 'Read CSSBuy Review',
  shippingTitle: 'CSSBuy Shipping Cost: how much does shipping cost?',
  shippingDesc: 'Shipping costs can vary depending on weight, dimensions, destination, shipping method, insurance and additional services. Always check the latest information for an accurate estimate of the total shipping cost.',
  shippingCta: 'View Shipping Cost Guide',
  couponTitle: 'CSSBuy Coupon & Discount Code',
  couponDesc: 'Find verified coupons and discount codes for CSSBuy. Always check the current validity of offers before using.',
  couponCta: 'View Coupons & Discounts',
  safetyTitle: 'Is CSSBuy safe? Understand before buying',
  safetyCard1: 'Account',
  safetyCard2: 'Payment',
  safetyCard3: 'Links',
  safetyCard4: 'Sellers',
  safetyCard5: 'QC',
  safetyCard6: 'Shipping',
  safetyCard7: 'Scams',
  safetyCta: 'Visit CSSBuy Safety Center',
  comparisonTitle: 'CSSBuy vs other platforms',
  comparisonFeature1: 'Product Research',
  comparisonFeature2: 'Spreadsheet',
  comparisonFeature3: 'QC',
  comparisonFeature4: 'Warehouse',
  comparisonFeature5: 'Shipping',
  comparisonPlatform1: 'CSSBuy',
  comparisonPlatform2: 'Superbuy',
  comparisonPlatform3: 'Sugargoo',
  comparisonPlatform4: 'AllChinaBuy',
  comparisonVerify: 'Verify',
  finalCtaTitle: 'Ready to continue your research?',
  finalCtaDesc: 'Explore our CSSBuy guides and resources to compare information, understand costs and make more informed decisions.',
  finalCtaBtn1: 'Explore CSSBuy Spreadsheet',
  finalCtaBtn2: 'Visit Main Website',
  articleTitle: 'CSSBuy Spreadsheet 2026: Complete Guide to Finding Products',
  articleMetaDesc: 'Complete guide to CSSBuy Spreadsheet. Learn how to use, find products, verify sellers, understand shipping costs, and make safe buying decisions.',
  readingTime: '8 min read',
  published: 'Published on August 26, 2026',
  updated: 'Updated on August 26, 2026',
  author: 'CSSBuyBR Team',
  articleIntro: 'CSSBuy Spreadsheet has become an essential tool for anyone who wants to research products in an organized and efficient way. In this complete guide, you will learn everything about how to use CSSBuy Spreadsheet to find the best products, verify trustworthy sellers, and understand all the costs involved in the buying process.',
  articleH2What: 'What is CSSBuy Spreadsheet?',
  articlePWhat: 'CSSBuy Spreadsheet is an organized resource that brings together product lists, seller links, categories and research information. It works as a structured catalog where you can browse different product categories, from sneakers and clothing to accessories and electronics. The main advantage is having all the information centralized in one place, making it easier to compare options and verify important details before placing an order.',
  articleH2How: 'How to Use CSSBuy Spreadsheet',
  articlePHow: 'To use CSSBuy Spreadsheet effectively, start by selecting the product category you are looking for. Each category contains organized lists with direct links to products. Before clicking any link, check the seller information, analyze available QC photos, and read the product notes. Always compare at least three options before making a final decision.',
  articleH2Categories: 'Main CSSBuy Spreadsheet Categories',
  articlePCategories: 'CSSBuy Spreadsheet is organized into categories that make navigation easy. The main categories include: Sneakers and Shoes, Hoodies and Sweaters, T-Shirts, Jackets, Pants and Shorts, Headwear, Sets, Underwear, Jerseys, Accessories, Bags, Belts, Perfumes and Other Stuff. Each category is kept up to date with new products and sellers regularly.',
  articleH2Qc: 'Understanding QC on CSSBuy',
  articlePQc: 'QC (Quality Control) is one of the most important aspects when using CSSBuy Spreadsheet. QC photos allow you to verify the quality of the product before it is shipped to your address. Always request detailed photos and check if the product matches the description and original seller photos.',
  articleH2Shipping: 'Shipping Costs and Freight',
  articlePShipping: 'CSSBuy shipping costs vary according to package weight, dimensions, final destination, chosen shipping method and additional services such as insurance or special packaging. It is essential to calculate all these costs before finalizing a purchase to avoid surprises. Also consider the package consolidation option to save on shipping.',
  articleH2Safety: 'Safety Tips for Buying',
  articlePSafety: 'Before making any purchase through CSSBuy, always check the product link, confirm the seller reputation, carefully analyze QC photos, verify the payment destination, confirm shipping conditions and calculate the complete final cost. Never share login information and use strong passwords to protect your account.',
  articleH2Faq: 'Frequently Asked Questions',
  faqQ1: 'Is CSSBuy Spreadsheet free?',
  faqA1: 'Yes, CSSBuy Spreadsheet is a free resource for product research. However, the listed products have their own costs set by the sellers.',
  faqQ2: 'How to check if a seller is trustworthy?',
  faqA2: 'Check the seller history, read reviews from other buyers, analyze QC photos and confirm that product links are active and match descriptions.',
  faqQ3: 'How long does CSSBuy shipping take?',
  faqA3: 'Shipping time depends on the chosen method and destination. Faster methods generally cost more, while economical options may take longer.',
  faqQ4: 'Can I trust QC photos?',
  faqA4: 'QC photos are a valuable tool, but always compare with the original product photos and check details such as materials, stitching and finishes.',
  articleH2Conclusion: 'Conclusion',
  articlePConclusion: 'CSSBuy Spreadsheet is a powerful tool for anyone who wants to research products in an organized way. By following the tips in this guide — verifying sellers, analyzing QC, calculating shipping costs and following security practices — you can make more informed and safe buying decisions. Continue exploring our guides and resources to deepen your knowledge.',
  relatedTitle: 'Related Articles',
  relatedArticle1: 'CSSBuy Review 2026: Features, Shipping, Safety & Pros and Cons',
  relatedArticle2: 'Is CSSBuy Legit? What Beginners Should Know',
  relatedArticle3: 'CSSBuy Shipping Cost: What Determines the Final Price?',
};